import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Header from './header';
import Nav from './nav';

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: 64 + 24, // MOBILE HEADER + padding
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: 92 + 24, // DESKTOP HEADER + padding
    // 不再預留左側空間
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export default function DashboardLayout() {
  const [openNav, setOpenNav] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('jwtData');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpenNav(true)} />
      <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />
      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
